import React from 'react'
import { inject, observer } from 'mobx-react'

import getProductsBySelection from 'src/helpers/getProductsBySelection'
import Ui from 'src/stores/ui'

import styles from './ProductCarousel.module.scss'
import Carousel from '../UI/Carousel/Carousel'
import ListProduct from '../ListProduct/ListProduct'
import LanguageContext from '../LanguageContext'

type Props = {
  fields: any
  brand?: string
  ui?: Ui
}

@inject('ui')
@observer
class ProductCarousel extends React.Component<Props> {
  render() {
    const { fields, brand, ui } = this.props

    const { selection } = fields
    const items = getProductsBySelection(selection, brand)
    const isDesktop = ui && ui.windowWidth >= 1024
    return (
      <section className={styles.productSlider}>
        <h3 className={styles.title}>{fields.title}</h3>
        <div>
          {isDesktop ? (
            <div className={styles.desktopWrapper}>
              <Carousel listView controls={false} hideArrows={items.length < 5}>
                {items.slice(0, 12).map((product: any, index: number) => (
                  <div key={index} className={styles.productSlide}>
                    <LanguageContext.Consumer>
                      {context => (
                        <ListProduct
                          product={product}
                          locale={context.locale}
                        />
                      )}
                    </LanguageContext.Consumer>
                  </div>
                ))}
              </Carousel>
            </div>
          ) : (
            <Carousel centeredView>
              {items.slice(0, 12).map((product: any, index: number) => (
                <div key={index} className={styles.productSlide}>
                  <LanguageContext.Consumer>
                    {context => (
                      <ListProduct product={product} locale={context.locale} />
                    )}
                  </LanguageContext.Consumer>
                </div>
              ))}
            </Carousel>
          )}
        </div>
      </section>
    )
  }
}

export default ProductCarousel
